import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TreatString } from '../../util/treatString';
import { MatDatepickerInputEvent } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { DateValidator } from '../../util/date.validator';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'DD/MM/YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'DD/MM/YYYY'
  },
};

@Component({
  selector: 'bra-date',
  templateUrl: './bra-date.component.html',
  styleUrls: ['./bra-date.component.css'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class BraDateComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: Date;
  @Output() valueChange = new EventEmitter();

  novoValor: string = "";
  novoValorChange = new EventEmitter();
  change(newValue) {
    if(newValue == null){
      return;
    }
    if(newValue._i != null && newValue._i.hasOwnProperty('year')) {
      this.value = new Date(
        newValue._i.year + "-" + 
        TreatString.padLeft((newValue._i.month + 1),"0",2) + "-" + 
        TreatString.padLeft(newValue._i.date,"0",2) + "T00:00:00");
      this.valueChange.emit(this.value);
      newValue._i = "29/01/1984";
      return;
    }
    var teste: string = newValue._d + "";
    var t2: string[] = teste.split(" ");
    if(newValue != null){
      this.value = new Date(
        t2[3] + "-"
        + this.retornaMes(t2[1]) + "-"
        + TreatString.padLeft(t2[2],"0",2)
        + "T00:00:00");
      if(newValue._i != null && newValue._i.length == 10){
        if(this.senddate.errors){
          this.valueChange.emit(this.value); 
        }
      }      
    }
  }

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  constructor() { }

  ngOnInit() {
  }

  senddate = new FormControl(new Date(), Validators.compose([Validators.required, DateValidator.date]));

  retornaMes = (mes: string): string => {
    if(mes == "Jan"){
      return "01";
    }
    else if(mes == "Feb"){
      return "02";
    }
    else if(mes == "Mar"){
      return "03";
    }
    else if(mes == "Apr"){
      return "04";
    }
    else if(mes == "May"){
      return "05";
    }
    else if(mes == "Jun"){
      return "06";
    }
    else if(mes == "Jul"){
      return "07";
    }
    else if(mes == "Aug"){
      return "08";
    }
    else if(mes == "Sep"){
      return "09";
    }
    else if(mes == "Oct"){
      return "10";
    }
    else if(mes == "Nov"){
      return "11";
    }
    else if(mes == "Dec"){
      return "12";
    }
    return "01";
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-date/bra-date.component.ts